import DesLibraryPreviewViewModel from 'viewmodel/DesLibraryPreviewViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesLibraryPreview extends DesBaseCatalogAcc {
    constructor() {
        super(DesLibraryPreviewViewModel);
    }

    get libraryId() {
        return this.getAttribute('libraryid') || this.getAttribute('library-id');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }


    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale', 'library-id', 'libraryid'];
    }
}

if (!window.customElements.get('des-library-preview')) {
    window.customElements.define('des-library-preview', DesLibraryPreview);
}
